import { useTranslation } from "react-i18next";
import { ScrollTop } from "primereact/scrolltop";
import DadosConsulta from "./DadosConsulta";
import EnderecoHist from "./EnderecoHist";
import HistoricoInfo from "./HistorioInfo";
import ListaConsulta from "./ListaConsulta";
import Empresas from "./Empresas";
import Acoes from "./Acoes";
import Score from "./Score";
import CCFS from "./CCFS";
import Apontamentos from "./Apontamentos";
import Cadastral from "./Cadastral";
import AcoesCompleta from "./AcoesCompleta";
import Informativo from "./Informativo";
import CompletaPF from "./CompletaPF";
import Pendencias from "./Pendencias";
import Protestos from "./Protestos";
import RendaPresumida from "./RendaPresumida";
import CompletaPJ from "./CompletaPJ";
import DadosConsultaPJ from "./DadosConsultaPJ";
import Socios from "./Socios";
import Aviso from "./Aviso";
import FaturamentoPresumido from "./FaturamentoPresumido";
import IndicadorPJ from "./IndicadorPJ";
import LimiteCreditoPJ from "./LimiteCreditoPJ";
import MaisNegocio from "./MaisNegocio";
import ScoreGrauAtvidadePJ from "./ScoreGrauAtividadePJ";
import ParticipacaoEmpresa from "./ParticipacaoEmpresa";
import ComportamentoFinanceiro from "./ComportamentoFinanceiro";
import LinhaCredito from "./LinhaCredito";
import Endividamento from "./Endividamento";
import PontualidadePagamento from "./PontualidadePagamento";
import HistoricoPagamento from "./HistoricoPagamento";
import ProtestoQuod from "./ProtestoQuod";
import IndicadorNegocio from "./IndicadorNegocio";
import HistoricoVencido from "./HistoricoVencido";
import GastoEstimadoPJ from "./GastoEstimadoPJ";
import ScoreInadimplenciaPJ from "./ScoreInadimplenciaPJ";
import AnaliseSetorial from "./AnaliseSetorial/AnaliseSetorial";
import { Gps895Page } from "./Gps895";
import { Gps894Page } from "./Gps894";
import { Gps391 } from "./Gps391";
import { Gps353 } from "./Gps353";
import { ProtestoNacional } from "./ProtestoNacional";
import SCPC from "./SCPC";
import RestricaoAvancadaScore from "./RestricaoAvancadaScore";
import RestricaoPalladium from "./RestricaoPalladium";
import RestricaoSilver from "./RestricaoSilver";
import { ProtestoCenprot } from "./ProtestoCenprot";
import { ProtestoNacionalCnpj } from "./ProtestoNacionalCnpj";
import { ProtestoNacionalCpf } from "./ProtestoNacionalCpf";
import { AntecedentesCriminaisPF } from "./AntecedentesCriminaisPF";
import { SerasaPremium, SpcSerasa } from "./SerasaConsultaAi";
import PendenciaFinanceira from "./PendenciaFinanceira";
import PessoaCadastral from "./PessoaCadastral";
import CreditoScore from "./CreditoScore";
import PessoaCadastralStandard from "./PessoaCadastralStandard";
import { InformacaoEposi } from "../../../components/InformacaoEposi";
import { InformacaoQuod } from "../../../components/InfomacaoQuod";
import { ReceitaFederal } from "./ReceitaFederal";
import { Pgfn } from "./Pgfn";
import CreditoPositivo from "./CreditoPositivo";
import AutenticaCartao from "./AutenticaCartao";
import AutenticaCadastral from "./AutenticaCadastral";
import PendenciaCompany from "./PedenciaCompany";
import CadastralNomeCompleto from "./CadastralNomeCompleto";
import GPS from "./GPS";
import { PendenciaScore } from "./PendenciaScore";
import { TST } from "./TST";
import { TRT } from "./TRT";
import { CadastralBacenScoreSCRPage } from "./CadastralBacenScoreSCR";
import AutoLaudo from "./AutoLaudo";
import { AutomotivaVeiculoProprietario } from "./AutomotivaVeiculoProprietario";
import { VeiculoProprietarioPage } from "./VeiculoProprietario";
import { FrotaPF } from "./FrotaPF";
import { FrotaPJ } from "./FrotaPJ";
import { CadastralPlus } from "./CadastralPlus";
import { CadastralEmpresa } from "./CadastralEmpresa";
import { BacenScoreSCRPage } from "./BacenScoreSCR";
import { DividaAtiva } from "./DividaAtiva";
import AcoesCompletaMensagem from "./AcoesCompletaMensagem";
import { CadastralV } from "./CadastralV";
import { CadastralVNome } from "./CadastralVNome";
import { ConsultaSCRPage } from "./ConsultaSCR/ConsultaSCR";
import Credito from "./Credito";
import { NidInteligenciaDadosPj } from "./NidInteligenciaDadosPj";
import BeneficioSocial from "./BeneficioSocial";
import RenunciasBeneficios from "./RenunciasBeneficios";
import { CeisPo } from "./CeisPo";
import PessoaAssistenteSocial from "./PessoaAssistenteSocial";
import ProtestoCartorio from "./ProtestoCartorio";
import RestricaoFullPF from "./RestricaoFullPF";
import RestricaoFullPJ from "./RestricaoFullPJ";
import AtlasEndereco from "./AtlasEndereco";
import CreditoScorePlus from "./CreditoScorePlus";



function isSetorPublico(cnae?: string | null): boolean {
  if (!cnae) return false;
  // CNAEs do setor público pertencem à divisão 84 (Administração Pública)
  return cnae.trim().startsWith('84');
}

export default function RespostaInsumoPage({
  resposta,
}: {
  resposta: any;
}) {

  const { t } = useTranslation();

  const setorPublico = isSetorPublico(resposta.dadosConsultaPJ?.cnae);

  // Trigger para novo layout: quando opcoesPai contiver E-posi Total Boletos
  const isConsultaNova = !!(resposta.informativo?.opcoesPai?.some((op: string) => op.trim() === 'E-posi Total Boletos'));

  // Produtos combinados Pendência + Score (BVS + iConsultei)
  const isPendenciaScore = !!(resposta.informativo?.opcoesPai?.some(
    (op: string) => op.trim() === 'PENDENCIA_SCORE_CPF_STANDARD' || op.trim() === 'PENDENCIA_SCORE_CNPJ_STANDARD'
  ));

  // Itens restritivos para Quadro de Avisos (somente no novo layout PJ)
  const resumoItens: Array<{ label: string; count: number }> = [];
  if (isConsultaNova && resposta.dadosConsultaPJ) {
    // Ações judiciais
    if (resposta.acoes) {
      const qtdResumo = resposta.acoes[0]?.resumos?.find((r: any) => r.label === 'Quantidade');
      resumoItens.push({
        label: 'AÇÕES JUDICIAIS',
        count: qtdResumo ? parseInt(qtdResumo.value) : resposta.acoes.length,
      });
    }

    // Dados de crédito restritivo (objeto credito com subcampos)
    if (resposta.credito) {
      const c = resposta.credito;
      if (c.PEND_FINANCEIRAS !== undefined)
        resumoItens.push({ label: 'PEND. FINANCEIRAS', count: Number(c.PEND_FINANCEIRAS?.QUANTIDADE_OCORRENCIA || 0) });
      if (c.PEND_REFIN !== undefined)
        resumoItens.push({ label: 'REFIN', count: Number(c.PEND_REFIN?.QUANTIDADE_OCORRENCIA || 0) });
      if (c.PEND_VENCIDAS !== undefined)
        resumoItens.push({ label: 'DÍVIDAS VENCIDAS', count: Number(c.PEND_VENCIDAS?.QUANTIDADE_OCORRENCIA || 0) });
      if (c.CH_SEM_FUNDOS_BACEN !== undefined)
        resumoItens.push({ label: 'CHEQUES SEM FUNDOS BACEN', count: Number(c.CH_SEM_FUNDOS_BACEN?.QUANTIDADE_OCORRENCIA || 0) });
      if (c.PROTESTOS !== undefined)
        resumoItens.push({ label: 'TÍTULOS PROTESTADOS', count: Number(c.PROTESTOS?.QUANTIDADE_OCORRENCIA || 0) });
    }

    // Pendência financeira separada (fora do objeto credito)
    if (!resposta.credito && resposta.pendenciaFinanceira !== undefined) {
      resumoItens.push({
        label: 'PEND. FINANCEIRAS',
        count: resposta.pendenciaFinanceira?.PEND_FINANCEIRAS?.OCORRENCIAS?.length ?? 0,
      });
    }

    // CCFS separado (fora do objeto credito)
    if (!resposta.credito && resposta.ccfs !== undefined) {
      resumoItens.push({
        label: 'CHEQUES SEM FUNDOS BACEN',
        count: Array.isArray(resposta.ccfs) ? resposta.ccfs.length : 0,
      });
    }

    // Protestos via showProtesto/cartorios (fonte separada do credito.PROTESTOS)
    if (resposta.showProtesto) {
      const qtdResumo = resposta.cartorios?.[0]?.resumos?.find((r: any) =>
        (r.label as string)?.toLowerCase().includes('quantidade')
      );
      const label = resposta.credito?.PROTESTOS !== undefined ? 'PROTESTOS (CARTÓRIOS)' : 'TÍTULOS PROTESTADOS';
      resumoItens.push({
        label,
        count: qtdResumo ? parseInt(qtdResumo.value) : (resposta.cartorios?.length || 0),
      });
    }

    // Dívida ativa separada
    if (!resposta.credito && resposta.dividaAtiva !== undefined) {
      resumoItens.push({
        label: 'DÍVIDA ATIVA',
        count: resposta.dividaAtiva ? 1 : 0,
      });
    }
  }

  return (
    <>

      <br></br>
      <br></br>
      {resposta.avisos.length > 0 && (
        <Aviso avisos={resposta.avisos}></Aviso>)}
      <br></br>
      {(resposta.dadosConsulta ||
        resposta.dadosConsultaPJ ||
        resposta.credito ||
        resposta.score ||
        resposta.scoreBoletoPJ ||
        resposta.acoes ||
        resposta.showApontamento ||
        (resposta.protestosQuod && resposta.protestosQuod.length > 0) ||
        (resposta.ccfs) ||
        resposta.rendaPresumida ||
        resposta.scoreGrauAtividadePJ ||
        resposta.comportamentoFinanceiro ||
        resposta.linhaCredito ||
        resposta.pontualidadePagamento ||
        resposta.historicoPagamento ||
        (resposta.endividamentos && resposta.endividamentos.length > 0) ||
        resposta.historicoVencido ||
        resposta.limiteCreditoPJ ||
        resposta.autenticacoesCartao ||
        resposta.quodAutenticaCadastral ||
        resposta.maisNegocio ||
        resposta.gastoEstimadoPJ ||
        resposta.faturamentosPresumido ||
        resposta.consulta ||
        resposta.scoreInadimplenciaPJ ||
        (resposta.empresas && resposta.empresas.length > 0) ||
        (resposta.socios && resposta.socios.length > 0) ||
        (resposta.participacoesEmpresa && resposta.participacoesEmpresa.length > 0) ||
        (resposta.enderecosHist && resposta.enderecosHist.length > 0) ||
        (resposta.emailsHist && resposta.emailsHist.length > 0) ||
        (resposta.conglomerados && resposta.conglomerados.length > 0) ||
        (resposta.calularesHist && resposta.calularesHist.length > 0) ||
        (resposta.telefonesHist && resposta.telefonesHist.length > 0) ||
        (resposta.analises && resposta.analises.length > 0) ||
        (resposta.indicadoresPJ && resposta.indicadoresPJ.length > 0) ||
        (resposta.indicadores && resposta.indicadores.length > 0)
      ) && !resposta.informativo.hideQuod && (<InformacaoQuod></InformacaoQuod>)}
      {resposta.dadosConsulta && (
        <DadosConsulta dadosConsulta={resposta.dadosConsulta}></DadosConsulta>)}
      {resposta.dadosConsultaPJ && (
        <DadosConsultaPJ capitalSocial={resposta.capitalSocial} dadosConsultaPJ={resposta.dadosConsultaPJ} isConsultaNova={isConsultaNova}></DadosConsultaPJ>
      )}
      {resposta.pessoa && (
        <> <br></br><Cadastral pessoa={resposta.pessoa}></Cadastral></>

      )}

      {resposta.completaPF && (
        <CompletaPF completaPF={resposta.completaPF}></CompletaPF>
      )}
      {resposta.completaPJ && (
        <CompletaPJ completaPJ={resposta.completaPJ} isConsultaNova={isConsultaNova}></CompletaPJ>
      )}
      {resumoItens.length > 0 && (
        <>
          <br />
          <div
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              border: '1px solid #E5E7EB',
              padding: '20px 24px',
            }}
          >
            <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '16px' }}>
              Resumo
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
              {resumoItens.map((item, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  {item.count > 0 ? (
                    <span className="pi pi-exclamation-triangle" style={{ color: '#EF4444', fontSize: '1.2rem', flexShrink: 0 }} />
                  ) : (
                    <span className="pi pi-check-circle" style={{ color: '#16A34A', fontSize: '1.2rem', flexShrink: 0 }} />
                  )}
                  <span style={{ fontSize: '0.8rem', fontWeight: 700, color: item.count > 0 ? '#EF4444' : '#374151', textTransform: 'uppercase' }}>
                    {item.label}:{' '}
                    <span style={{ color: item.count > 0 ? '#EF4444' : '#374151' }}>
                      {item.count > 0 ? `${item.count} OCORRÊNCIA${item.count !== 1 ? 'S' : ''}` : 'NADA CONSTA'}
                    </span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      {resposta.conglomerados && resposta.conglomerados.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={false} label={t('conglomerados')} historicos={resposta.conglomerados} isConsultaNova={isConsultaNova} ></HistoricoInfo>
        </>
      )}
      {resposta.enderecosHist && resposta.enderecosHist.length > 0 && (
        <>
          <br></br>
          <EnderecoHist enderecos={resposta.enderecosHist} isConsultaNova={isConsultaNova} ></EnderecoHist>
        </>
      )}
      {resposta.emailsHist && resposta.emailsHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('email')} historicos={resposta.emailsHist} isConsultaNova={isConsultaNova} ></HistoricoInfo>
        </>
      )}

      {resposta.calularesHist && resposta.calularesHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('celular')} historicos={resposta.calularesHist} isConsultaNova={isConsultaNova} ></HistoricoInfo>
        </>
      )}
      {resposta.telefonesHist && resposta.telefonesHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('fone')} historicos={resposta.telefonesHist} isConsultaNova={isConsultaNova} ></HistoricoInfo>
        </>
      )}
      {resposta.socios && resposta.socios.length > 0 && (
        <>
          <br></br>
          <Socios showRestricao={resposta.showApontamento} socios={resposta.socios} isConsultaNova={isConsultaNova} ></Socios>
        </>
      )}
      {resposta.participacoesEmpresa && resposta.participacoesEmpresa.length > 0 && (
        <>
          <br></br>
          <ParticipacaoEmpresa showRestricao={resposta.showApontamento} participacoes={resposta.participacoesEmpresa} isConsultaNova={isConsultaNova} ></ParticipacaoEmpresa>
        </>
      )}
      {setorPublico && (
        <>
          <br></br>
          <div
            style={{
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '6px',
              padding: '1.5rem 2rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '0.75rem',
              color: '#856404',
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center',
            }}
          >
            <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', color: '#ffc107' }}></i>
            <span>Empresa do setor público não tem score.</span>
          </div>
        </>
      )}
      {!setorPublico && resposta.score && (
        <>
          <br></br>
          <Score scoreBoleto={false} label="Score" score={resposta.score} isConsultaNova={isConsultaNova} ></Score>
        </>
      )}
      {!setorPublico && resposta.scoreBoletoPJ && (
        <>
          <br></br>
          <Score scoreBoleto={true} label="Score Boleto PJ" score={resposta.scoreBoletoPJ} isConsultaNova={isConsultaNova} ></Score>
        </>
      )}
      {resposta.limiteCreditoPJ && (
        <>
          <br></br>
          <LimiteCreditoPJ limiteCreditoPJ={resposta.limiteCreditoPJ} ></LimiteCreditoPJ>
        </>
      )}
      {resposta.scoreInadimplenciaPJ && (
        <>
          <br></br>
          <ScoreInadimplenciaPJ
            scoreInadimplenciaPJ={resposta.scoreInadimplenciaPJ}
          ></ScoreInadimplenciaPJ>
        </>
      )}
      {resposta.scoreGrauAtividadePJ && (
        <>
          <br></br>
          <ScoreGrauAtvidadePJ scoreGrauAtividadePJ={resposta.scoreGrauAtividadePJ} ></ScoreGrauAtvidadePJ>
        </>
      )}
      {resposta.faturamentosPresumido && (
        <>
          <br></br>
          <FaturamentoPresumido faturamentos={resposta.faturamentosPresumido} ></FaturamentoPresumido>
        </>
      )}
      {resposta.maisNegocio && (
        <>
          <br></br>
          <MaisNegocio maisNegocio={resposta.maisNegocio} ></MaisNegocio>
        </>
      )}
      {resposta.gastoEstimadoPJ && (
        <>
          <br></br>
          <GastoEstimadoPJ
            gastoEstimadoPJ={resposta.gastoEstimadoPJ}
          ></GastoEstimadoPJ>
        </>
      )}
      {resposta.comportamentoFinanceiro && (
        <>
          <br></br>
          <ComportamentoFinanceiro comportamento={resposta.comportamentoFinanceiro} ></ComportamentoFinanceiro>
        </>
      )}
      {resposta.linhaCredito && (
        <>
          <br></br>
          <LinhaCredito linhaCredito={resposta.linhaCredito} ></LinhaCredito>
        </>
      )}
      {resposta.endividamentos && resposta.endividamentos.length > 0 && (
        <>
          <br></br>
          <Endividamento endividamentos={resposta.endividamentos} ></Endividamento>
        </>
      )}
      {resposta.pontualidadePagamento && (
        <>
          <br></br>
          <PontualidadePagamento pontualidadePagamento={resposta.pontualidadePagamento} ></PontualidadePagamento>
        </>
      )}
      {resposta.historicoPagamento && (
        <>
          <br></br>
          <HistoricoPagamento historicoPagamento={resposta.historicoPagamento} ></HistoricoPagamento>
        </>
      )}
      {resposta.historicoVencido && (
        <>
          <br></br>
          <HistoricoVencido
            historicoVencido={resposta.historicoVencido}
          ></HistoricoVencido>
        </>
      )}
      {resposta.rendaPresumida && (
        <>
          <br></br>
          <RendaPresumida rendaPresumida={resposta.rendaPresumida} ></RendaPresumida>
        </>
      )}
      {resposta.analises && resposta.analises.length > 0 && (
        <>
          <br></br>
          <AnaliseSetorial analises={resposta.analises} ></AnaliseSetorial>
        </>
      )}


      {resposta.empresas && resposta.empresas.length > 0 && (
        <>
          <br></br>
          <Empresas empresas={resposta.empresas} isConsultaNova={isConsultaNova} ></Empresas>
        </>
      )}

      {resposta.indicadoresPJ && resposta.indicadoresPJ.length > 0 && (
        <>
          <br></br>
          <IndicadorPJ indicadores={resposta.indicadoresPJ}></IndicadorPJ> </>)}

      {resposta.indicadores && resposta.indicadores.length > 0 && (
        <>
          <br></br>
          <IndicadorNegocio indicadores={resposta.indicadores}></IndicadorNegocio> </>)}
      {resposta.showApontamento && (
        <>
          <br></br>
          <Apontamentos apontamentos={resposta.apontamentos} isConsultaNova={isConsultaNova} ></Apontamentos>
        </>
      )}
      {resposta.ccfs && (
        <>
          <br></br>
          <CCFS ccfs={resposta.ccfs} ></CCFS>
        </>
      )}
      {resposta.acoes && (
        <>
          <br></br>
          <Acoes acoes={resposta.acoes} isConsultaNova={isConsultaNova} ></Acoes>
        </>
      )}
      {/* {resposta.protestosQuod && (
        <>
          <br></br>
          <ProtestoQuod protestos={resposta.protestosQuod} isConsultaNova={isConsultaNova} ></ProtestoQuod>
        </>
      )} */}
      {resposta.autenticacoesCartao && (
        <>
          {" "}
          <br></br>
          <AutenticaCartao autenticaCartao={resposta.autenticacoesCartao} />
        </>
      )}
      {resposta.quodAutenticaCadastral && (
        <>
          {" "}
          <br></br>
          <AutenticaCadastral quodAutenticaCadastral={resposta.quodAutenticaCadastral} />
        </>
      )}
      {resposta.consulta && (
        <>
          <br></br>
          <ListaConsulta consulta={resposta.consulta} isConsultaNova={isConsultaNova} ></ListaConsulta>
        </>
      )}
      {(resposta.showProtesto ||
        resposta.restricaoSilver ||
        resposta.restricaoPalladium ||
        resposta.restricaoAvancadaScore ||
        resposta.restricaoFullPf ||
        resposta.restricaoFullPj ||
        resposta.atlasEndereco ||
        resposta.scpc ||
        resposta.pendencia ||
        resposta.protestoCentroProt ||
        resposta.protestoNacionalCnpj ||
        resposta.protestoNacionalCpf ||
        resposta.antecedentesCriminais ||
        resposta.creditoCompletoScore ||
        resposta.creditoBasicoPlus ||
        resposta.gps894 ||
        resposta.gps895 ||
        resposta.creditoScore ||
        resposta.creditoScorePlus ||
        resposta.creditoPositivo ||
        resposta.pessoaCadastral ||
        resposta.pessoaCadastralStandard ||
        resposta.pgfn ||
        resposta.gps ||
        resposta.protestoCartorio ||
        resposta.protestoCartorioRegional ||
        resposta.trt ||
        resposta.dividaAtiva ||
        resposta.tst ||
        resposta.cadastralSrcBacenScorePositivo ||
        resposta.autoVistoria ||
        resposta.srcBacenScorePositivo ||
        resposta.autoLeilaoVipGold ||
        resposta.autoPlatinum ||
        resposta.automotivaVeiculoProprietario ||
        resposta.cadastralNomeCompleto ||
        resposta.pendenciaCompany ||
        resposta.acoesCompleta ||
        resposta.veiculoProprietario ||
        resposta.cadastralEmpresaCnpj ||
        resposta.cadastralPlus ||
        resposta.nidInteligenciaDadosPj ||
        resposta.recebimentosViaBoletosTedCartao ||
        resposta.pagamentosViaBoletosTedCartao ||
        resposta.concentracaoRecebimentos ||
        resposta.concentracaoPagamentos ||
        resposta.indiceDiasAtraso ||
        resposta.liquidezPagamentos ||
        resposta.liquidezRecebimentos ||
        resposta.pagamentosBoletos ||
        resposta.recebimentosBoletos ||
        resposta.scoreEvolucao ||
        resposta.predicaoRecebimentosBoleto ||
        resposta.receitaFederal ||
        resposta.beneficioSocial ||
        resposta.renunciasBeneficios ||
        resposta.pessoaAssistenteSocial ||
        (isPendenciaScore && (resposta.gps || resposta.creditoScore)))
        && (<InformacaoEposi></InformacaoEposi>)}
      {resposta.pessoaCadastral && (
        <>
          {" "}
          <br></br>
          <PessoaCadastral pessoaCadastral={resposta.pessoaCadastral}></PessoaCadastral>
        </>
      )}
      {resposta.pessoaCadastralStandard && (
        <>
          {" "}
          <br></br>
          <PessoaCadastralStandard pessoaCadastralStandard={resposta.pessoaCadastralStandard}></PessoaCadastralStandard>
        </>
      )}
      {resposta.cadastralEmpresaCnpj && (
        <>
          <br></br>
          <CadastralEmpresa cadastralEmpresaCnpj={resposta.cadastralEmpresaCnpj} isConsultaNova={isConsultaNova} ></CadastralEmpresa>
        </>
      )}
      {resposta.protestoNacional && (
        <>
          <br></br>
          <ProtestoNacional data={resposta.protestoNacional} ></ProtestoNacional>
        </>
      )}
      {resposta.protestoCentroProt && (
        <>
          <br></br>
          <ProtestoCenprot data={resposta.protestoCentroProt} ></ProtestoCenprot>
        </>
      )}
      {resposta.protestoNacionalCnpj && (
        <>
          <br></br>
          <ProtestoNacionalCnpj data={resposta.protestoNacionalCnpj} isConsultaNova={isConsultaNova} ></ProtestoNacionalCnpj>
        </>
      )}
      {resposta.protestoNacionalCpf && (
        <>
          <br></br>
          <ProtestoNacionalCpf data={resposta.protestoNacionalCpf} isConsultaNova={isConsultaNova} ></ProtestoNacionalCpf>
        </>
      )}
      {resposta.antecedentesCriminais && (
        <>
          <br></br>
          <AntecedentesCriminaisPF data={resposta.antecedentesCriminais} isConsultaNova={isConsultaNova} ></AntecedentesCriminaisPF>
        </>
      )}
      {resposta.creditoCompletoScore && (
        <>
          <br></br>
          <SerasaPremium data={resposta.creditoCompletoScore} isConsultaNova={isConsultaNova} ></SerasaPremium>
        </>
      )}
      {resposta.creditoBasicoPlus && (
        <>
          <br></br>
          <SpcSerasa data={resposta.creditoBasicoPlus} isConsultaNova={isConsultaNova} ></SpcSerasa>
        </>
      )}
      {resposta.pendencia && (
        <>
          <br></br>
          <Pendencias pendencia={resposta.pendencia} ></Pendencias>
        </>
      )}
      {resposta.gps353 && (
        <>
          {" "}
          <br></br>
          <Gps353 {...resposta.gps353} />
        </>
      )}
      {resposta.gps391 && (
        <>
          {" "}
          <br></br>
          <Gps391 data={resposta.gps391} />
        </>
      )}
      {resposta.gps894 && Object.getOwnPropertyNames(resposta.gps894).length > 0 && (
        <>
          {" "}
          <br></br>
          <Gps894Page {...resposta.gps894} />
        </>
      )}

      {resposta.gps895 && Object.getOwnPropertyNames(resposta.gps895).length > 0 && (
        <>
          {" "}
          <br></br>
          <Gps895Page {...resposta.gps895} />
        </>
      )}
      {resposta.acoesCompleta && resposta.acoesCompleta.length > 0 && (
        <>
          <br></br>
          <AcoesCompleta acoes={resposta.acoesCompleta} isConsultaNova={isConsultaNova} ></AcoesCompleta>
        </>
      )}
      {resposta.showProtesto && (
        <>
          <br></br>
          <Protestos cartorios={resposta.cartorios} isConsultaNova={isConsultaNova} ></Protestos>
        </>
      )}
      {resposta.restricaoSilver && (
        <>
          <br></br>
          <RestricaoSilver restricaoSilver={resposta.restricaoSilver} ></RestricaoSilver>
        </>
      )}
      {resposta.creditoScore && !isPendenciaScore && (
        <>
          <br></br>
          <CreditoScore creditoScore={resposta.creditoScore} informativo={resposta.informativo} ></CreditoScore>
        </>
      )}
      {resposta.creditoScorePlus && !isPendenciaScore && (
        <>
          <br></br>
          <CreditoScorePlus creditoScore={resposta.creditoScorePlus} informativo={resposta.informativo} ></CreditoScorePlus>
        </>
      )}
      {resposta.creditoPositivo && (
        <>
          <br></br>
          <CreditoPositivo creditoPositivo={resposta.creditoPositivo} ></CreditoPositivo>
        </>
      )}
      {resposta.restricaoPalladium && (
        <>
          <br></br>
          <RestricaoPalladium restricaoPalladium={resposta.restricaoPalladium} ></RestricaoPalladium>
        </>
      )}
      {resposta.restricaoAvancadaScore && (
        <>
          <br></br>
          <RestricaoAvancadaScore restricaoAvancadaScore={resposta.restricaoAvancadaScore} ></RestricaoAvancadaScore>
        </>
      )}
      {resposta.restricaoFullPf && (
        <>
          <br></br>
          <RestricaoFullPF restricaoFullPf={resposta.restricaoFullPf} ></RestricaoFullPF>
        </>
      )}
      {resposta.restricaoFullPj && (
        <>
          <br></br>
          <RestricaoFullPJ restricaoFullPj={resposta.restricaoFullPj} ></RestricaoFullPJ>
        </>
      )}
      {resposta.atlasEndereco && (
        <>
          <br></br>
          <AtlasEndereco atlasEndereco={resposta.atlasEndereco} ></AtlasEndereco>
        </>
      )}
      {resposta.scpc && (
        <>
          <br></br>
          <SCPC scpc={resposta.scpc} ></SCPC>
        </>
      )}
      
      {resposta.pendenciaFinanceira && (
        <>
          <br></br>
          <PendenciaFinanceira pendenciaFinanceira={resposta.pendenciaFinanceira} isConsultaNova={isConsultaNova} ></PendenciaFinanceira>
        </>
      )}
      {resposta.credito && (
        <>
          <br></br>
          <Credito credito={resposta.credito} isConsultaNova={isConsultaNova} />
        </>
      )}
      {resposta.protestoCartorio && (
        <>
          <br></br>
          <ProtestoCartorio data={resposta.protestoCartorio}></ProtestoCartorio>
        </>
      )}
      {resposta.protestoCartorioRegional && (
        <>
          <br></br>
          <ProtestoCartorio data={resposta.protestoCartorioRegional}></ProtestoCartorio>
        </>
      )}
      {resposta.receitaFederal && (
        <>
          <br></br>
          <ReceitaFederal receitaFederal={resposta.receitaFederal} ></ReceitaFederal>
        </>
      )}
      {resposta.nidInteligenciaDadosPj && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.nidInteligenciaDadosPj} />
        </>
      )}
      {resposta.recebimentosViaBoletosTedCartao && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.recebimentosViaBoletosTedCartao} />
        </>
      )}
      {resposta.pagamentosViaBoletosTedCartao && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.pagamentosViaBoletosTedCartao} />
        </>
      )}
      {resposta.pagamentosBoletos && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.pagamentosBoletos} />
        </>
      )}
      {resposta.recebimentosBoletos && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.recebimentosBoletos} />
        </>
      )}
      {resposta.scoreEvolucao && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.scoreEvolucao} />
        </>
      )}
      {resposta.concentracaoRecebimentos && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.concentracaoRecebimentos} />
        </>
      )}
      {resposta.concentracaoPagamentos && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.concentracaoPagamentos} />
        </>
      )}
      {resposta.indiceDiasAtraso && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.indiceDiasAtraso} />
        </>
      )}
      {resposta.liquidezPagamentos && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.liquidezPagamentos} />
        </>
      )}
      {resposta.liquidezRecebimentos && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.liquidezRecebimentos} />
        </>
      )}
      {resposta.predicaoRecebimentosBoleto && (
        <>
          <br></br>
          <NidInteligenciaDadosPj data={resposta.predicaoRecebimentosBoleto} />
        </>
      )}
      {resposta.pgfn && (
        <>
          <br></br>
          <Pgfn pgfn={resposta.pgfn} ></Pgfn>
        </>
      )}
      {resposta.pendenciaCompany && (
        <>
          <br></br>
          <PendenciaCompany
            pendenciaCompany={resposta.pendenciaCompany}
          ></PendenciaCompany>
        </>
      )}
      {resposta.cadastralNomeCompleto && (
        <>
          <br></br>
          <CadastralNomeCompleto data={resposta.cadastralNomeCompleto} />
        </>
      )}
      {resposta.dividaAtiva && (
        <>
          <br></br>
          <DividaAtiva dividaAtiva={resposta.dividaAtiva} ></DividaAtiva>
        </>
      )}
      {resposta.beneficioSocial && (
        <>
          <br></br>
          <BeneficioSocial beneficioSocial={resposta.beneficioSocial}></BeneficioSocial>
        </>
      )}
      {resposta.renunciasBeneficios && (
        <>
          <br></br>
          <RenunciasBeneficios renunciasBeneficios={resposta.renunciasBeneficios}></RenunciasBeneficios>
        </>
      )}
      {resposta.ceisPo && (
        <>
          <br></br>
          <CeisPo ceisPo={resposta.ceisPo} />
        </>
      )}
      {resposta.pessoaAssistenteSocial && (
        <>
          <br></br>
          <PessoaAssistenteSocial pessoaAssistenteSocial={resposta.pessoaAssistenteSocial} />
        </>
      )}
      <br></br>
      {isPendenciaScore && (resposta.gps || resposta.creditoScore) && (
        <>
          <br></br>
          <PendenciaScore gps={resposta.gps} creditoScore={resposta.creditoScore} />
        </>
      )}
      {resposta.gps && !isPendenciaScore && (
        <>
          {" "}
          <br></br>
          <GPS gps={resposta.gps} />
        </>
      )}
      {resposta.trt && (
        <>
          <br></br>
          <TRT data={resposta.trt} />
        </>
      )}
      {resposta.tst && (
        <>
          <br></br>
          <TST data={resposta.tst} />
        </>
      )}
      {resposta.cadastralSrcBacenScorePositivo && (
        <>
          {" "}
          <br></br>
          <CadastralBacenScoreSCRPage {...resposta.cadastralSrcBacenScorePositivo} />
        </>
      )}

      {resposta.acoesCompletaMensagem && (
        <>
          <br></br>
          <AcoesCompletaMensagem mensagem={resposta.acoesCompletaMensagem}></AcoesCompletaMensagem>
        </>
      )}

      {resposta.srcBacenScorePositivo && (
        <>
          {" "}
          <br></br>
          <BacenScoreSCRPage {...resposta.srcBacenScorePositivo} />
        </>
      )}
      {resposta.scrSeletor && (
        <>
          {" "}
          <br></br>
          <ConsultaSCRPage {...resposta} />
        </>
      )}

      {resposta.autoVistoria && (
        <>
          <br></br>
          <AutoLaudo title={'Auto Vistoria'} data={resposta.autoVistoria} />
        </>
      )}
      {resposta.autoLeilaoVipGold && (
        <>
          <br></br>
          <AutoLaudo title={'Auto Leilão vip'} data={resposta.autoLeilaoVipGold} />
        </>
      )}
      {resposta.autoPlatinum && (
        <>
          <br></br>
          <AutoLaudo title={'Auto Platinum'} data={resposta.autoPlatinum} />
        </>
      )}
      {resposta.automotivaVeiculoProprietario && (
        <>
          {" "}
          <br></br>
          <AutomotivaVeiculoProprietario
            {...resposta.automotivaVeiculoProprietario}
          />
        </>
      )}
      {resposta.veiculoProprietario && (
        <>
          <br></br>
          <VeiculoProprietarioPage  {...resposta.veiculoProprietario}
          />
        </>
      )}
      {resposta.frotaPf && (
        <>
          <br></br>
          <FrotaPF {...resposta.frotaPf} />
        </>
      )}
      {resposta.frotaPj && (
        <>
          <br></br>
          <FrotaPJ {...resposta.frotaPj} />
        </>
      )}
      {resposta.cadastralPlus && (
        <CadastralPlus
          cadastralPlus={resposta.cadastralPlus}
        ></CadastralPlus>
      )}

      {resposta.cadastralVNome && (
        <CadastralVNome
          cadastralVNome={resposta.cadastralVNome}
        ></CadastralVNome>
      )}

      {resposta.cadastralV && (
        <CadastralV
          cadastralV={resposta.cadastralV}
        ></CadastralV>
      )}

      <br></br>
      <br></br>
      <Informativo informativo={resposta.informativo}></Informativo>

      <ScrollTop
        style={{ marginBottom: "5rem" }}
        className="border-round bg-primary"
        icon="pi pi-arrow-up text-base"
      />
    </>
  );
}
